import audioSrc from './tip.wav'

export class AudioManager {
  private static instance: AudioManager | null = null
  private audioElement: HTMLAudioElement

  private constructor() {
    this.audioElement = new Audio()
    document.body.appendChild(this.audioElement)
  }

  public static getInstance(): AudioManager {
    if (!AudioManager.instance) {
      AudioManager.instance = new AudioManager()
    }
    return AudioManager.instance
  }

  public getAudioElement(): HTMLAudioElement {
    return this.audioElement
  }

  /**
   *
   * @param src 音频文件路径 || 音频文件链接 || 音频文件base64
   */
  public playAudio(src = audioSrc): void {
    this.audioElement.src = src
    this.audioElement.addEventListener('canplaythrough', () => {
      this.audioElement.play()
    })
  }

  public stopAudio(): void {
    this.audioElement.pause()
    this.audioElement.currentTime = 0
  }

  public pauseAudio(): void {
    this.audioElement.pause()
  }

  public resumeAudio(): void {
    this.audioElement.play()
  }

  public destroyAudio(): void {
    this.audioElement.pause()
    this.audioElement.src = ''
    this.audioElement.removeEventListener('canplaythrough', () => {
      this.audioElement.play()
    })
    if (this.audioElement.parentNode) {
      this.audioElement.addEventListener('canplaythrough', () => {
        this.audioElement.play()
      })
      this.audioElement.parentNode.removeChild(this.audioElement)
    }
    AudioManager.instance = null
  }
}
